// formik components
import { Form, Formik } from "formik";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

// example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// CompanyDetail layout schemas for form and form feilds
import { useLocation, useNavigate, useParams } from "react-router-dom";
import EmployeeInfo from "./info";
import initialValues from "./schemas/initialValues";
import form from "./schemas/form";
import { ImageService } from "services/imageService";
import toast from "react-hot-toast";
import Loading from "components/Common/Loading";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { authSelector } from "redux/selector";
import { AuthService } from "../../../services/authService";
import { UserService } from "../../../services/userService";
import validation from "./schemas/validations";

function EmployeeDetail() {
  const { id } = useParams();
  const location = useLocation();
  const navigation = useNavigate();
  const [data, setData] = useState();
  const { user } = useSelector(authSelector);
  const [refetch, setRefetch] = useState(false);
  const containEdit = location.pathname?.includes("/edit");

  const { formId, formField } = form;

  useEffect(() => {
    if (!id) return;
    (async () => {
      try {
        const { data } = await UserService.getById(id);
        setData(data);
      } catch (error) {
        toast.error(error?.response?.data?.message || "Lấy dữ liệu thất bại");
      }
    })();
  }, [id]);

  const handleBack = () => navigation(-1);

  const submitForm = async (values, actions) => {
    try {
      const payload = {
        ...values,
      };
      if (values.avatar && values?.avatar?.preview != "") {
        try {
          const [url] = await ImageService.uploadMany([values.avatar]);
          if (url) {
            payload.avatar = url;
          }
        } catch (err) {
          console.error("Error uploading image:", err);
        }
      }
      if (id) {
        if (payload?.avatar && (typeof payload.avatar !== "string" || payload.avatar?.preview)) {
          payload.avatar = "";
        }

        await UserService.update(id, payload);
        await ImageService.deleteImage(data.avatar);
      } else {
        await UserService.createUserSuperAdmin(payload);
      }
      actions.setSubmitting(false);
      !id && actions.resetForm();
      toast.success(`${id ? "Cập nhật" : "Tạo"} thành công`);
      setTimeout(() => {
        navigation(-1);
      }, 1500);
    } catch (error) {
      toast.error(error?.response?.data?.message || `${id ? "Cập nhật" : "Tạo"} thất bại`);
      actions.setSubmitting(false);
      console.error({ error });
    }
  };

  const handleSubmit = (values, actions) => {
    submitForm(values, actions);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3} mb={20}>
        <Grid container justifyContent="center" sx={{ height: "100%" }}>
          <Grid item xs={12} lg={12}>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <SoftBox p={2}>
                      <SoftBox>
                        <EmployeeInfo
                          formData={{
                            values,
                            touched,
                            formField,
                            errors,
                            setFieldValue,
                          }}
                          data={data}
                        />
                        <SoftBox mt={10} width="100%" display="flex" justifyContent="space-between">
                          <SoftButton variant="gradient" color="light" onClick={handleBack}>
                            Trở về
                          </SoftButton>
                          {id && !containEdit && (
                            <SoftButton
                              variant="gradient"
                              color="dark"
                              href={`/manage-employees/employees/${id}/edit`}
                            >
                              Chỉnh sửa
                            </SoftButton>
                          )}
                          {(!id || (id && containEdit)) && (
                            <SoftBox display="flex" gap={3}>
                              <SoftButton
                                disabled={isSubmitting}
                                type="submit"
                                variant="gradient"
                                color="dark"
                              >
                                {isSubmitting ? (
                                  <Loading width={25} height={25} />
                                ) : id && containEdit ? (
                                  "Cập nhật"
                                ) : (
                                  "Tạo"
                                )}
                              </SoftButton>
                            </SoftBox>
                          )}
                        </SoftBox>
                      </SoftBox>
                    </SoftBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default EmployeeDetail;
